export const getActionListStyles = () => ({
  actionList: {
    marginTop: 30,
    '& .action-list-group': {
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      '& .campaign-objective': {
        marginBottom: 2,
      },
    },
  },
  title: {
    fontWeight: 'bold',
    fontSize: 16,
    lineHeight: '19px',
    color: '#000000',
    marginBottom: 24,
  },
});
